// src/app/shared/main-menu.data.ts
import { MenuItem } from "./menu.model";

export const MAIN_MENU: MenuItem[] = [
  { label: "Bookings", icon: "event", link: "/bookings" },
  { label: "Aircrafts", icon: "flight", link: "/aircrafts" },
  {
    label: "Flights",
    icon: "flight_takeoff",
    children: [
      { label: "View flights", link: "/flights" },
      { label: "Add a flight", link: "/flight" },
    ],
  },
];
